import React from "react";
import "./LoanReview.css";
const LoanReview = () => {
  return (
    <div className="row" id="application_summary">
      <div className="col-lg-12">
        <h4>Application Summary</h4>
        <div className="card mt-3">
          <div className="card-body">
            <form action="" className="row g-3">
              <div className="col-lg-4">
                <div className="form-group">
                  <label className="form-label">Name</label>
                  <h6 className="fw-600 fs-16">Akash Nikam</h6>
                </div>
              </div>
              <div className="col-lg-4">
                <div className="form-group">
                  <label className="form-label">File No</label>
                  <h6 className="fw-600 fs-16">686191929</h6>
                </div>
              </div>
              <div className="col-lg-4">
                <div className="form-group">
                  <label className="form-label">Loan Product</label>
                  <h6 className="fw-600 fs-16">
                    Non-Residential Premises Loan
                  </h6>
                </div>
              </div>
              <div className="col-lg-4">
                <div className="form-group">
                  <label className="form-label">Loan Amount</label>
                  <h6 className="fw-600 fs-16">24,30,000</h6>
                </div>
              </div>
              <div className="col-lg-4">
                <div className="form-group">
                  <label className="form-label">Application Date</label>
                  <h6 className="fw-600 fs-16">25-Feb-2023</h6>
                </div>
              </div>
              <div className="col-lg-4">
                <div className="form-group">
                  <label className="form-label">Channel</label>
                  <h6 className="fw-600 fs-16">
                    HDFC Sales Private Limited - Pune
                  </h6>
                </div>
              </div>
            </form>

            <ul className="steps-wrap">
              <li className="step active">
                <div className="top_box">
                  <span className="text">SALES EXECUTIVE</span>
                  <p>VINIT RAMAKANT SAWANT</p>
                </div>
                <span className="icon">
                  <i className="fas fa-check"></i>
                </span>
                <span className="text">Application Submitted</span>
                <p>Submitted on 27th Feb 2023</p>
              </li>
              <li className="step active">
                <div className="top_box">
                  <span className="text">SALES EXECUTIVE</span>
                  <p>VINIT RAMAKANT SAWANT</p>
                </div>
                <span className="icon">
                  <i className="fas fa-check"></i>
                </span>
                <span className="text">Under Initital Review</span>
                <p>Submitted on 27th Feb 2023</p>
              </li>
              <li className="step active">
                <div className="top_box">
                  <span className="text">CREDIT APPRAISER</span>
                  <p>KUNAL RAVINDRA PATIL</p>
                </div>
                <span className="icon">
                  <i className="fas fa-check"></i>
                </span>
                <span className="text">Under Credit Assessment</span>
                <p>Submitted on 27th Feb 2023</p>
              </li>
              <li className="step process">
                <div className="top_box">
                  <span className="text">LEGAL APPRAISER</span>
                  <p>KUNAL RAVINDRA PATIL</p>
                </div>
                <span className="icon">4</span>
                <span className="text">Sanctioned</span>
                <p>Submitted on 27th Feb 2023</p>
              </li>
              <li className="step">
                <span className="icon">5</span>
                <span className="text">First Disbursement</span>
                <p>Submitted on 27th Feb 2023</p>
              </li>
            </ul>

            <div className="alert alert-warning text-center mt-4" role="alert">
              <p style={{ color: "#1b1b1b" }}>
                Clarifications are awaited for further processing of your loan
                application.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoanReview;
